import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import Business from "components/Business/Business";

import ProjectContainer from "containers/Project/Project";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as businessReducer from "containers/Business/BusinessReducer";
import * as projectReducer from "containers/Project/reducer";
import * as globalReducer from "containers/App/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as runReducer from "containers/Run/reducer";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

class BusinessContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.init(props.blueprintId, props.datasetId);
  }

  componentDidUpdate(prevProps) {
    const {
      id,
      optimized,
      hasConstraints,
      modelCount,
      blueprintId,
      hasJob,
      isDone,
      datasetId,
      init,
      resetBudget,
      match
    } = this.props;

    if (prevProps.id !== id) {
      init(blueprintId, datasetId);
    }

    // Hacky way to set the budget when model updates
    if (
      modelCount !== prevProps.modelCount &&
      hasJob &&
      (isDone !== true || prevProps.isDone !== true) &&
      prevProps.hasJob === true
    ) {
      resetBudget(true);
    }
  }

  componentWillUnmount() {
    const { updateCurrentProjectId, resetDatasetOutcome, updateIsEditBlueprint, reset } = this.props;
    reset();
    resetDatasetOutcome();
    return updateCurrentProjectId(undefined);
  }

  render() {
    const { isTableauMode, id } = this.props;

    return isTableauMode ? <ProjectContainer id={id} /> : <Business {...this.props} />;
  }
}

/*
      hasSplits,
      compareScenarioIndex,
      updateCompareScenarioIndex,
      removeShortlist,
      isAFO,
      refresh,
      aibleViewType,
      viewingScenarioIndex,
      canEditSegments,
*/

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    init: (blueprintId, datasetId) => dispatch(businessReducer.init(id, blueprintId, datasetId)),
    updateCurrentStep: (stepId) => dispatch(businessReducer.updateCurrentStep(id, stepId)),

    resetBudget: (skipShowLoading) => dispatch(projectReducer.resetBudget(id, false, skipShowLoading)),
    resetDatasetOutcome: () => dispatch(projectReducer.resetDatasetOutcome(id)),
    updateCurrentProjectId: (newId) => dispatch(globalReducer.updateCurrentProjectId(newId)),

    deploy: () => dispatch(projectReducer.deploy(id)),

    rerunSegment: (segmentId) => dispatch(projectReducer.rerunSegment(id, segmentId)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    viewAllScenarios: () => dispatch(projectReducer.viewAllScenarios(id)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),
    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id)),
    removeShortlist: () => dispatch(projectReducer.removeShortlist(id)),
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),

    updateCompareScenarioIndex: (index) => dispatch(projectReducer.updateCompareScenarioIndex(id, index)),

    trainAI: (options) =>
      dispatch(businessReducer.startModelRun(ownProps.id, ownProps.runId, ownProps.blueprintId, options)),

    updateIsEditBlueprint: (label) => dispatch(businessReducer.updateIsEditBlueprint(id, label)),
    saveBlueprint: (isApply) => dispatch(businessReducer.saveBlueprint(id, isApply)),
    updateLabel: (label) => {
      dispatch((dispatch, getState) => {
        const isEditBlueprint = businessReducer.getIsEditBlueprint(getState(), id);
        const innerId = projectReducer.getInnerId(getState(), id);

        const runId = innerId !== undefined ? innerId : isEditBlueprint ? "editBlueprint" : id;
        return dispatch(setupReducer.updateLabel(runId, label));
      });
    },
    reset: () => dispatch(businessReducer.reset(id)),
    retrainRun: () => dispatch(projectReducer.retrainRun(id))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const queryParams = ownProps && ownProps.location ? ownProps.location.search : undefined;
  const paramsObj = queryParams ? queryString.parse(queryParams) : undefined;

  const type = wizardReducer.STEP_TYPE.ACADEMIC_CHOOSE_DATASET.id;

  const wStep =
    Object.keys(wizardReducer.STEP_TYPE).filter((s) => wizardReducer.STEP_TYPE[s].id === type).length > 0
      ? Object.keys(wizardReducer.STEP_TYPE)
          .filter((s) => wizardReducer.STEP_TYPE[s].id === type)
          .map((s) => wizardReducer.STEP_TYPE[s])[0]
      : undefined;

  const optimized = projectReducer.getOptimized(state, id);
  const isEditBlueprint = businessReducer.getIsEditBlueprint(state, id);

  const runId =
    optimized && optimized.innerId !== undefined ? optimized.innerId : isEditBlueprint ? "editBlueprint" : id;

  const blueprintId =
    paramsObj && paramsObj.blueprint ? paramsObj.blueprint : businessReducer.getBlueprintId(state, id);

  const datasetId = paramsObj && paramsObj.dataset ? paramsObj.dataset : undefined;

  return {
    id: id,
    isProjectNotFound: unifiedProjectReducer.getIsProjectNotFound(state, id),
    isError: projectReducer.getIsError(state, id, runId),
    blueprintId: blueprintId,
    blueprint: setupReducer.getBlueprintFromSetup(state, runId),
    isForecast: setupReducer.getIsForecast(state, runId),
    forecastMode: setupReducer.getForecastModeH(state, runId),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, runId),
    datasetId: datasetId,
    optimized: optimized,
    currentStep: businessReducer.getCurrentStep(state, id),
    hasSplits: projectReducer.getHasSplits(state, id),
    modelCount: projectReducer.getTotalModelCount(state, id),

    hasJob: Object.keys(runReducer.getJob(state, runId)).length > 0,

    isDone: runReducer.getIsDone(state, runId),

    userName: loginReducer.getUserName(state),

    selectedScenario: projectReducer.getSelectedScenario(state, id),
    allScenarios: projectReducer.getAllScenarios(state, id),
    approvedScenario: projectReducer.getApprovedScenario(state, id, runId),
    showShortListed: projectReducer.getShowShortListed(state, id),
    showPending: projectReducer.getShowPending(state, id),
    modelGroups: projectReducer.getModelGroups(state, id),
    project: projectReducer.getProject(state, id),
    optimizer: projectReducer.getOptimizer(state, id),

    isLoadingCompare: projectReducer.getIsLoadingCompare(state, id),

    isTableauMode: ownProps.isTableauMode ? ownProps.isTableauMode : globalReducer.getIsTableauMode(state),

    isAudit: businessReducer.getIsAudit(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    viewingScenarioIndex: projectReducer.getViewingScenarioIndex(state, id),
    compareScenarioIndex: projectReducer.getCompareScenarioIndex(state, id),

    isNextEnabled:
      wStep === undefined || wStep.isEnabled === undefined ? true : wStep.isEnabled(state, { ...ownProps, id: "new" }),

    setup: setupReducer.getSetup(state, runId),

    isEditBlueprint: isEditBlueprint,
    editBlueprintId: businessReducer.getEditBlueprintRunId(state, id),
    isSavingBlueprint: businessReducer.getIsSavingBlueprint(state, id),
    hasLoadedAllJobs: projectReducer.hasLoadedAllJobs(state, id),

    isRetraining: projectReducer.getIsRetraining(state, id),
    hasSetupIgnoreChanged:
      optimized && optimized.innerId !== undefined ? setupReducer.getSetupIgnoreChanged(state, runId) : false
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BusinessContainer);
